import { render, staticRenderFns } from "./FormFinishGiftCard.vue?vue&type=template&id=2dff1f20&scoped=true"
import script from "./FormFinishGiftCard.vue?vue&type=script&lang=js"
export * from "./FormFinishGiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff1f20",
  null
  
)

export default component.exports